import { memo } from 'react';

interface NotesFiltersProps {
  filters: { subject: string; location: string; notes: string };
  filtersExpanded: boolean;
  activeFilterCount: number;
  onToggleFilters: () => void;
  onSearch: () => void;
  onClear: () => void;
  onUpdateFilter: (field: 'subject' | 'location' | 'notes', value: string) => void;
}

export const NotesFilters = memo(function NotesFilters({
  filters,
  filtersExpanded,
  activeFilterCount,
  onToggleFilters,
  onSearch,
  onClear,
  onUpdateFilter,
}: NotesFiltersProps) {
  return (
    <>
      {/* Mobile Filters Toggle Bar */}
      <div className="mobile-filters-bar">
        <button className="btn-filters-toggle" onClick={onToggleFilters}>
          <i className="fa fa-filter"></i>
          Filters
          {activeFilterCount > 0 && (
            <span className="filter-count-badge">{activeFilterCount}</span>
          )}
          <i
            className={`fa ${filtersExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}
          ></i>
        </button>
        <button className="btn-search-mobile" onClick={onSearch}>
          <i className="fa fa-search"></i>
        </button>
      </div>

      {/* Filters */}
      <div
        className={`filters-section${filtersExpanded ? ' filters-expanded' : ''}`}
      >
        <div className="filters-row">
          <div className="filter-group">
            <label>Location</label>
            <input
              type="text"
              className="filter-input"
              value={filters.location}
              placeholder="Enter Location"
              onChange={(e) => onUpdateFilter('location', e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
          </div>
          <div className="filter-group">
            <label>Subject</label>
            <input
              type="text"
              className="filter-input"
              value={filters.subject}
              placeholder="Enter Subject"
              onChange={(e) => onUpdateFilter('subject', e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
          </div>
          <div className="filter-group">
            <label>Notes</label>
            <input
              type="text"
              className="filter-input"
              value={filters.notes}
              placeholder="Search Notes"
              onChange={(e) => onUpdateFilter('notes', e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
          </div>
          <div className="filter-buttons">
            <button className="btn-search" onClick={onSearch}>
              Search
            </button>
            <button className="btn-clear" onClick={onClear}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </>
  );
});
